import Enumerator from '../global/Enumerator';
import { HouseholdExpenseType } from './HouseholdExpense.enum';

export const householdLixiTypes = [
  'groceries',
  'recreation_and_entertainment',
  'clothing_and_personal_care',
  'telephone_internet_pay_tv_and_media_streaming_subscriptions',
  'other',
  'pet_care',
  'public_or_government_primary_and_secondary_education',
  'private_schooling_and_tuition',
  'higher_education_vocational_training_and_professional_fees',
  'childcare',
  'child_and_spousal_maintenance',
  'health_insurance',
  'medical_and_health',
  'sickness_and_personal_accident_insurance_life_insurance',
  'transport',
  'general_basic_insurances',
  'rent',
  'board',
  'primary_residence_running_costs',
  'body_corporate_fees_strata_fees_and_land_tax_on_owner_occupied_principal_place_of_residence',
  'secondary_residence_running_costs',
  'investment_property_running_costs'
];

export class HouseholdLixiType extends Enumerator {
  static default() {
    return this.of('groceries');
  }
}

HouseholdLixiType.initEnum({
  groceries: {
    get title() {
      return 'Groceries';
    },
    get types() {
      return [HouseholdExpenseType.food_and_supermarket.name];
    }
  },
  recreation_and_entertainment: {
    get title() {
      return 'Recreation and entertainment';
    },
    get types() {
      return [
        HouseholdExpenseType.coffees_lunches_takeaway.name,
        HouseholdExpenseType.entertainment.name,
        HouseholdExpenseType.domestic_holidays.name,
        HouseholdExpenseType.gym_fees_sport_other_health_and_wellness.name,
        HouseholdExpenseType.cigarettes_and_alcohol.name
      ];
    }
  },
  clothing_and_personal_care: {
    get title() {
      return 'Clothing and personal care';
    },
    get types() {
      return [
        HouseholdExpenseType.clothing_shoes_and_accessories.name,
        HouseholdExpenseType.hairdressing_and_grooming.name
      ];
    }
  },
  telephone_internet_pay_tv_and_media_streaming_subscriptions: {
    get title() {
      return 'Telephone, internet, pay TV and media streaming subscriptions';
    },
    get types() {
      return [
        HouseholdExpenseType.phone_internet_and_pay_tv.name,
        HouseholdExpenseType.media_streaming_and_subscription_services.name
      ];
    }
  },
  other: {
    get title() {
      return 'Other';
    },
    get types() {
      return [
        HouseholdExpenseType.gifts_and_celebrations.name,
        HouseholdExpenseType.other_discretionary_expenses.name,
        HouseholdExpenseType.recreational_vehicle_running_costs.name
      ];
    }
  },
  pet_care: {
    get title() {
      return 'Pet Care';
    },
    get types() {
      return [HouseholdExpenseType.pets.name];
    }
  },
  public_or_government_primary_and_secondary_education: {
    get title() {
      return 'Public or Government Primary and Secondary Education';
    },
    get types() {
      return [HouseholdExpenseType.public_education_costs.name];
    }
  },
  private_schooling_and_tuition: {
    get title() {
      return 'Private Schooling and Tuition';
    },
    get types() {
      return [HouseholdExpenseType.private_education_costs.name];
    }
  },
  higher_education_vocational_training_and_professional_fees: {
    get title() {
      return 'Higher Education, Vocational Training and Professional Fees';
    },
    get types() {
      return [HouseholdExpenseType.tertiary_and_vocational_education.name];
    }
  },
  childcare: {
    get title() {
      return 'Childcare';
    },
    get types() {
      return [HouseholdExpenseType.childcare.name];
    }
  },
  child_and_spousal_maintenance: {
    get title() {
      return 'Child and Spousal Maintenance';
    },
    get types() {
      return [HouseholdExpenseType.child_or_spousal_maintenance.name];
    }
  },
  health_insurance: {
    get title() {
      return 'Health Insurance';
    },
    get types() {
      return [HouseholdExpenseType.private_health_insurance.name];
    }
  },
  medical_and_health: {
    get title() {
      return 'Medical and health';
    },
    get types() {
      return [HouseholdExpenseType.doctor_dentist_pharmacy_glasses.name];
    }
  },
  sickness_and_personal_accident_insurance_life_insurance: {
    get title() {
      return 'Sickness and Personal Accident Insurance, Life Insurance';
    },
    get types() {
      return [HouseholdExpenseType.life_trauma_income_insurance.name];
    }
  },
  transport: {
    get title() {
      return 'Transport';
    },
    get types() {
      return [
        HouseholdExpenseType.essential_vehicle_running_cost.name,
        HouseholdExpenseType.public_transport_taxis_and_ride_share_commuting_airfares.name
      ];
    }
  },
  general_basic_insurances: {
    get title() {
      return 'General Basic Insurances';
    },
    get types() {
      return [HouseholdExpenseType.essential_vehicle_insurance.name];
    }
  },
  rent: {
    get title() {
      return 'Rent';
    },
    get types() {
      return [HouseholdExpenseType.current_rent_expense.name];
    }
  },
  board: {
    get title() {
      return 'Board';
    },
    get types() {
      return [HouseholdExpenseType.ongoing_board_expense.name];
    }
  },
  primary_residence_running_costs: {
    get title() {
      return 'Primary Residence Running Costs';
    },
    get types() {
      return [HouseholdExpenseType.primary_residence_running_costs.name];
    }
  },
  body_corporate_fees_strata_fees_and_land_tax_on_owner_occupied_principal_place_of_residence: {
    get title() {
      return 'Body Corporate Fees, Strata Fees and Land Tax on Owner Occupied Principal Place of Residence';
    },
    get types() {
      return [HouseholdExpenseType.primary_residence_body_corp.name];
    }
  },
  secondary_residence_running_costs: {
    get title() {
      return 'Secondary Residence Running Costs';
    },
    get types() {
      return [
        HouseholdExpenseType.secondary_residence_running_costs.name,
        HouseholdExpenseType.secondary_residence_body_corp.name
      ];
    }
  },
  investment_property_running_costs: {
    get title() {
      return 'Investment Property Running Costs';
    },
    get types() {
      return [
        HouseholdExpenseType.investment_property_running_costs.name,
        HouseholdExpenseType.investment_property_body_corp.name
      ];
    }
  }
});

export default {
  householdLixiTypes,
  HouseholdLixiType
};
